import { format } from "date-fns";

export const INITIAL_FORM_DATA = {
  id_oficina: "",
  iddepto: "",
  resolucion: "",
  trans: "",
  iduser: "",
  unidad: "",
  tv: "",
  estado: "",
  fecha1: format(new Date(new Date().getFullYear(), 0, 1), "yyyy-MM-dd"),
  fecha2: format(new Date(), "yyyy-MM-dd"),
};

export const TABLE_HEADERS = [
  { text: "N°", value: "gestion", sortable: true, width: "50px" },
  {
    text: "AUTORIZACIÓN",
    value: "cite",
    sortable: false,
    width: "110px",
  },
  {
    text: "NOMBRE/CARGO",
    value: "nombre-cargo",
    sortable: false,
    width: "200px",
  },
  {
    text: "PROGRAMA",
    value: "programa",
    sortable: false,
    align: "center",
    width: "150px",
  },
  {
    text: "LUGAR/TRANSPORTE",
    value: "lugar-transporte",
    sortable: false,
    align: "center",
    width: "150px",
  },
  {
    text: "IDA/RETORNO",
    value: "fechas",
    sortable: false,
    align: "center",
    width: "150px",
  },
  {
    text: "TIPO/RESOLUCIÓN",
    value: "tipo-resolucion",
    sortable: false,
    align: "center",
    width: "150px",
  },
  {
    text: "DÍAS",
    value: "dias",
    sortable: false,
    align: "center",
    width: "80px",
  },
  {
    text: "ESTADO",
    value: "estado",
    sortable: false,
    align: "center",
    width: "100px",
  },
  {
    text: "VIÁTICOS",
    value: "viatico",
    sortable: false,
    align: "center",
    width: "120px",
  },
  {
    text: "PASAJE",
    value: "pasaje",
    sortable: false,
    align: "center",
    width: "120px",
  },
];

export const FILTER_FIELDS_CONFIG = [
  {
    model: "id_oficina",
    label: "Programa",
    itemsKey: "unitItems",
    class: "d-flex",
  },
  {
    model: "unidad",
    label: "Oficina",
    itemsKey: "officeItems",
    class: "flex-grow-0 flex-shrink-0",
  },
  {
    model: "iddepto",
    label: "Departamento",
    itemsKey: "departmentItems",
    class: "flex-grow-0 flex-shrink-0",
  },
  {
    model: "resolucion",
    label: "Resolución",
    itemsKey: "resolutionItems",
    class: "d-flex",
  },
  {
    model: "trans",
    label: "Transporte",
    itemsKey: "transportItems",
    class: "d-flex",
  },
  {
    model: "iduser",
    label: "Usuario",
    itemsKey: "userItems",
    class: "d-flex",
  },
  {
    model: "tv",
    label: "Tipo de viaje",
    itemsKey: "tripTypeItems",
    class: "d-flex",
  },
  {
    model: "estado",
    label: "Estado",
    itemsKey: "statusItems",
    class: "d-flex",
  },
];

export const DATE_FIELDS_CONFIG = [
  { model: "fecha1", label: "Fecha Inicio", menu: false },
  { model: "fecha2", label: "Fecha Fin", menu: false },
];
